import state from '@/store/modules/listsDashboards/state';
import mutations from '@/store/modules/listsDashboards/mutations';
import actions from '@/store/modules/listsDashboards/actions';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
